import { Box, Skeleton } from '@mui/material';
import React from 'react';

export const SkeletonRows = ({
  pageSize,
  rowHeight = 45,
  gap = 12,
  marginTop = 50,
}: {
  pageSize?: number;
  rowHeight?: number;
  gap?: number;
  marginTop?: number;
}) => (
  <>
    {[...Array(pageSize)].map((_, i) => (
      <Box
        component="tr"
        // eslint-disable-next-line react/no-array-index-key
        key={i}
        sx={{
          display: 'block',
          position: 'absolute',
          top: `${i * (rowHeight + gap) + marginTop}px`,
          width: '100%',
        }}
      >
        <Skeleton
          component="td"
          animation="wave"
          variant="rectangular"
          sx={{
            mx: 1.5,
            mt: 1.5,
            borderRadius: '6px',
            height: `${rowHeight}px`,
          }}
        />
      </Box>
    ))}
  </>
);
